const apiKeys = {
  firebaseKeys: {
    apiKey: 'AIzaSyABSpveij9lFGiDkM6JYQ9u-iG7Y3CXPa8',
    authDomain: 'gardenshare-890ac.firebaseapp.com',
    databaseURL: 'https://gardenshare-890ac.firebaseio.com',
    projectId: 'gardenshare-890ac',
    storageBucket: 'gardenshare-890ac.appspot.com',
    messagingSenderId: '853670082998',
  },
  zipcodeKey: 'js-nnysoPbH0OqN3avSQlfZX0zOYoZbHhfsFZuSyyB9n1rEcVGpJiCbuVv2o4b0TBLd',
};

export default apiKeys;

// js-nnysoPbH0OqN3avSQlfZX0zOYoZbHhfsFZuSyyB9n1rEcVGpJiCbuVv2o4b0TBLd
// 3Wb0nmnMxjCSbMROv6oOE3nLrqizc079Y8euinfLPSqgzlKVKtgJC341KTKMkoRC
